/* The module bar's two controls (designs/intake-ui-parity.md UP3), split
   out of the retired per-domain Dashboard so the one intake shell
   (intake-unified-form.md UF8) and any admin sub-bar can share them. */
import { useEffect, useRef, useState, type JSX } from "react";

export function NavBtn({
  label,
  active,
  primary = false,
  onClick,
}: {
  label: string;
  active: boolean;
  /* the bar's ONE call to action — filled accent, so a reader scanning the
     nav knows where actual input happens. At most one per bar. */
  primary?: boolean;
  onClick: () => void;
}): JSX.Element {
  return (
    <button
      className={`navbtn${primary ? " primary" : ""}${active ? " active" : ""}`}
      onClick={onClick}
    >
      {label}
    </button>
  );
}

interface MenuItem {
  label: string;
  active: boolean;
  onClick: () => void;
}

export function NavDropdown({
  label,
  active,
  items,
}: {
  label: string;
  active: boolean;
  items: MenuItem[];
}): JSX.Element {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const onDown = (e: MouseEvent): void => {
      /* the wrapper div always renders, so the ref is set whenever this runs */
      if (!ref.current!.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, [open]);
  return (
    <div className="nav-menu" ref={ref}>
      <button className={active ? "navbtn active" : "navbtn"} onClick={() => setOpen((o) => !o)}>
        {label} ▾
      </button>
      {open && (
        <div className="nav-dropdown">
          {items.map((it) => (
            <button
              key={it.label}
              className={it.active ? "on" : ""}
              onClick={() => {
                it.onClick();
                setOpen(false);
              }}
            >
              {it.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
